import { Trans } from "@lingui/macro";
import { useMediaQuery, useTheme } from "@mui/material";
import { UiBox, UiDivider, UiTypography } from "@smp/ui";
import { testAppendAttr } from "@smp/utils";

import { useContextDialogPurchase } from "../../../context";
import { Period } from "./period";

export const Periods = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    actions: { productSelectedChange },
    state: { paymentTypeSelected, productList, productSelected },
  } = useContextDialogPurchase();

  if (!productList) {
    return null;
  }

  if (productSelected.type !== "plan-product") {
    return null;
  }

  return (
    <UiBox display="flex" flexDirection="column" mb={4}>
      <UiBox mb={2}>
        <UiTypography variant="h4">
          {paymentTypeSelected === "recurring" ? (
            <Trans>Charge period</Trans>
          ) : (
            <Trans>Plan period</Trans>
          )}
        </UiTypography>
      </UiBox>
      <UiBox>
        <UiBox display="flex" flexDirection={isMobile ? "column" : "row"}>
          {productList
            .sort((a, b) => {
              if (a.period_units === b.period_units) {
                return a.period_length - b.period_length;
              }

              return a.period_units - b.period_units;
            })
            .map((product) => (
              <Period
                {...testAppendAttr("class", `purchase_plan_period`)}
                isActive={
                  productSelected.period_length === product.period_length &&
                  productSelected.period_units === product.period_units
                }
                onClick={productSelectedChange}
                key={`${product.period_length}:${product.period_units}`}
                product={product}
              />
            ))}
        </UiBox>
      </UiBox>
      <UiBox mt={4}>
        <UiDivider />
      </UiBox>
    </UiBox>
  );
};
